window.addEventListener('cart.checkout', (e) => {
    let { cart, order } = e.detail;
    let cartItems = order.items;

    let gtag = window.gtag || console.log;
    // ecommerce tracking
    gtag('event', 'purchase', {
        transaction_id: `${ order.id }`,
        affiliation: `${ window.env['APP_NAME'] }`,
        value: `${ _.get(order, 'amount_billed') }`,
        currency: "NZD",
        tax: `${ _.get(order, 'gst') }`,
        shipping: `${ _.get(order, 'freight_total') }`,
        items: _.chain(cartItems)
            .map((item, index) => {

                return {
                    id: `${ _.get(item, 'price_code')}`,
                    name: `${ _.get(item, 'price_description')}`,
                    quantity: `${ _.get(item, 'quantity')}`,
                    price: `${ _.get(item, 'item_price')}`,
                    list_position: index,
                }
            }).value()
    });
})
